
import { Component, Vue } from 'vue-property-decorator'
import ListItemBase from '@/components/atoms/ListItemBase.vue'

/**
 * liタグ
 */
@Component({
  components: {
    ListItemBase,
  },
})
export default class ListItem extends Vue {}
